import { HUImageDtoSchema, convertImageFromDto } from "@modules/dtos/imageDto"
import { Coach, ProfileTypeOf, User } from "@modules/profile/profileTypes"
import dayjs from "dayjs"
import { z } from "zod"

export const UserDtoSchema = z.object({
  id: z.string(),
  username: z.string(),
  firstname: z.string(),
  lastname: z.string(),
  avatar: HUImageDtoSchema.nullable(),
})

export const CoachDtoSchema = UserDtoSchema.extend({
  stripeAccountInError: z.boolean(),
})

export type UserDto = z.infer<typeof UserDtoSchema>
export type CoachDto = z.infer<typeof CoachDtoSchema>

export function convertUserFromDto(dto: UserDto): User {
  return {
    id: dto.id,
    _type: ProfileTypeOf,
    firstname: dto.firstname,
    lastname: dto.lastname,
    username: dto.username,
    avatar: dto.avatar ? convertImageFromDto(dto.avatar) : undefined,
  }
}

export function convertCoachFromDto(dto: CoachDto): Coach {
  return {
    ...convertUserFromDto(dto),
    stripeAccountInError: dto.stripeAccountInError,
  }
}

export function convertSASRequestsProfileFromDto(dto: RequestsSASProfileDto) {
  const { subscriptionId, subscriptionDate, ...profile } = dto
  return {
    subscriptionId,
    subscriptionDate: dayjs(subscriptionDate).toDate(),
    profile: convertUserFromDto(profile),
  }
}

export type RequestsSASProfileDto = {
  subscriptionId: string
  subscriptionDate: string
} & UserDto
